import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import StickyButton from '@/components/atom/buttons/StickyButton';
import { StickyButtonWrapper } from '@/components/templates/communication/Magazine/MagazineDetailTemplate/index';
import { MagazineBottomButtonType, MagazineDetailVo } from '@/types/magazine';

interface Props {
  faq: MagazineDetailVo;
  bottomButtonText: string;
  shouldShowEventText: boolean;
  onClickButton: () => void;
}

const FaqStickyButton: FunctionComponent<Props> = ({ faq, bottomButtonText, onClickButton, shouldShowEventText }) => {
  const EventContent = () => {
    switch (faq.bottomButtonType) {
      case MagazineBottomButtonType.DIAGNOSIS:
        return <></>;
      case MagazineBottomButtonType.QUESTION:
        return <></>;
    }
  };

  return (
    <StickyButtonWrapper>
      <StickyArea>
        <StickyButton.Button textAsH2={true} text={bottomButtonText} onClick={onClickButton} />
        {shouldShowEventText && <EventContent />}
      </StickyArea>
    </StickyButtonWrapper>
  );
};

export default FaqStickyButton;

const StickyArea = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    div + div {
        margin: 0;
    }
`;
